import FastfoodIcon from '@mui/icons-material/Fastfood';
import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { BenefitMetadataExtensionInterface } from '../../../../extension/interface/benefit-metadata.extension.interface';

export class LunchBenefitMetadataExtension extends BenefitMetadataExtensionInterface {
  benefitId: BenefitDTOBenefitEnum = BenefitDTOBenefitEnum.Lunch;
  get Icon(): React.ComponentType<SvgIconProps> {
    return FastfoodIcon;
  }
}
